
export enum SearchPropertyKey {
    inventoryNumberWithoutPrefix = 'inventoryNumberWithoutPrefix',
    routeNumber = 'routeNumber',
    blockNumber = 'blockNumber',
    stopName = 'stopName'
}

export interface SearchConfig {
    /**
     * The searchable type
     */
    searchPropertyKey: SearchPropertyKey;
    /**
     * How many chars the query must contain before it starts searching for the specified searchable type
     */
    minQueryLength: number;
    /**
     * Which strategy to use for the search
     */
    searchStrategy: SearchStrategy;
    /**
     * Fuzzy search config, which is only used if Fuzzy Search is chosen as searchStrategy
     */
    fuzzySearchConfig?: FuzzySearchConfig;
}

export interface FuzzySearchConfig {
    tolerance: number;
}

export enum SearchStrategy {
    ExactSearch = 'ExactSearch',
    FuzzySearch = 'FuzzySearch',
}

export interface SearchResultItem {
    title: string;
    subTitle: string;
    value: string;
    tag: string;
    state: string;
    id: string;
    scrollableId: string;
    type: string;
    iconClass?: string;
    matchingSearchKey: SearchPropertyKey;
    matchingQuery: string;
}
